module.exports = __webpack_public_path__ + "static/media/confused-pound-light.607236bf.svg";